export default "__VITE_ASSET__E0v6HVfy__"